
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/services/dedicated-development-teams",
      function () {
        return require("private-next-pages/services/dedicated-development-teams.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/services/dedicated-development-teams"])
      });
    }
  